module.exports = __webpack_public_path__ + "img/thumb_2019-05.160af0a4.jpg";